import { Switch, Typography } from "@mui/material";
import { useCallback } from "react";
import { Link } from "react-router-dom";
import { useUpdateAvailabilityMutation } from "src/api/services/availabilityApi";
import { Column, ProviderAvailability } from "src/api/types";
import { ROWS_PER_PAGE } from "src/constants/rowPerPage";

export const useColumns = (): Column<ProviderAvailability>[] => {
  const [updateAvailability] = useUpdateAvailabilityMutation();

  const handleToggleActive = useCallback(
    (id: number, is_active: boolean) => {
      updateAvailability({
        availability_id: id,
        body: { is_active },
      });
    },
    [updateAvailability],
  );

  return [
    {
      id: "Id",
      label: "id",
      minWidth: 150,
      align: "center",
      orderable: false,
      format: (row) => row.date,
      render: (row) => (
        <Link to={`${row.id}?p=0&l=${ROWS_PER_PAGE[0]}`}>{`${row.id}`}</Link>
      ),
    },
    {
      id: "available",
      label: "Available",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.date,
      render: (row) => (
        <Switch
          checked={row.is_active}
          onChange={(event) => handleToggleActive(row.id, event.target.checked)}
          size="small"
        />
      ),
    },
    {
      id: "date",
      label: "Date",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.date,
      render: (row) => <Typography>{row.date}</Typography>,
    },
    {
      id: "start_time",
      label: "Start Time",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.date,
      render: (row) => <Typography>{row.start_time}</Typography>,
    },
    {
      id: "end_time",
      label: "End Time",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.date,
      render: (row) => <Typography>{row.end_time}</Typography>,
    },
  ];
};
